import React, {useEffect} from 'react';
import {useHistory} from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {useQuery} from "../../../shared/hooks/useQuery";
import {useAuth} from "../../../shared/hooks/useAuth";

const ReactSwal = withReactContent(
    Swal.mixin({
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn btn-warning btn-lg',
            cancelButton: 'btn btn-default btn-lg',
            actions: 'text-center',
        },
    }),
)

const failedLoginAlert = (error) => {
    if (typeof error !== "string") {
        if (!error.message) {
            error.message = 'กรุณาลองใหม่อีกครั้ง<br/>(Please try again.)'
        } else {
            switch (error.message) {
                case "calendar_error":
                    error.message = "ไม่พบข้อมูลปฏิทินการศึกษา<br/>กรุณาติดต่อผู้ดูแลระบบ<br/>(The education calendar could not be found.<br/>Please contact your administrator.)"
                    break;
                case "OAUTH_GET_FAILED":
                    error.message = "Failed to get oauth token."
                    break;
                case "PROFILE_NOT_FOUND":
                    error.message = "Failed to get user profile"
                    break;
                case "router_error":
                    error.message = "Failed to get router."
                    break;
                case "data_scope_error":
                    error.message = "Failed to get data scope."
                    break;
                case "OAUTH_LOG_SAVE_FAILED":
                    error.message = "Failed to oauth log."
                    break;
                default:
                    error.message = "กรุณาลองใหม่อีกครั้ง<br/>(Please try again.)"
            }
        }
    }
    ReactSwal.fire({
        title: 'พบปัญหาการยืนยันตัวตนเข้าใช้งาน',
        html: typeof error === "string" ? error : error.message,
    })
    .then(async () => {
        window.location.href = '/';
    })
}

const OAuthCallback = (props) => {
    let history = useHistory()
    const {loginByOauth} = useAuth()

    let [query, search] = useQuery()

    useEffect(() => {
        initial()
    }, [])

    const initial = async () => {

        //ตัวอย่าง http query
        // session_state=ecfe24f7-154c-48b9-9f18-59b69a3e252d
        // code=d7ca5c76-355f-492e-b528-beb605cdd00d.ecfe24f7-154c-48b9-9f18-59b69a3e252d.4f7bf381-62e8-4f97-8673-b27c5fcfbb3e
        const sessionState = query.get("session_state")
        const code = query.get("code")

        if (!sessionState || !code) {
            failedLoginAlert("ไม่พบข้อมูลสำหรับการยืนยันตัวตน")
            return
        }

        try {
            await loginByOauth(code, sessionState, search)
        } catch (e) {
            console.log(e)
            failedLoginAlert(e)
        }
    }

    return (
        <></>
    )
}

export default OAuthCallback